// What the Feedback sheet can't read from the URL or storage: the troubleshoot
// session on screen. Pages register it; the sheet reads it at send time.
let current = { sessionId: null };

export function setFeedbackContext(patch) {
  current = { ...current, ...patch };
}

export function getFeedbackContext() {
  return { ...current };
}
